import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { ANALYTIC_TYPE_STORAGE_KEY_MAP } from '../types/analytics.constants';

/** Public inteface for `@monorepo/analytics` */
@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  #storage: Promise<Storage> | null = null;

  constructor(private storage: Storage) {}

  #getStorage(): Promise<Storage> {
    if (!this.#storage)
      this.#storage = this.storage.create().catch((e) => {
        this.#storage = null;
        throw e;
      });
    return this.#storage;
  }

  async cleanup(): Promise<void> {
    try {
      const store = await this.#getStorage();
      await Promise.all(Object.values(ANALYTIC_TYPE_STORAGE_KEY_MAP).map((key) => store.remove(key)));
    } catch (e) {
      console.error('[AnalyticsService] Error clearing stored analytics data', e);
    }
  }
}
